import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo } from "react";
import { useMediaQuery } from "@mui/material";
import i18n from "i18next";
import { flagMap, getLanguageDisplay, Language } from "./languageUtils";
const useSwitchLanguage = (props) => {
    const { setSelectedLanguage, selectedLanguage, handleMenuClose } = props;
    const isLargeScreen = useMediaQuery("(min-width:900px)");
    useEffect(() => {
        const storedLang = localStorage.getItem("i18nextLng");
        const initialLang = storedLang && Object.values(Language).includes(storedLang)
            ? storedLang
            : Language.NL;
        setSelectedLanguage(initialLang);
        i18n.changeLanguage(initialLang);
    }, []);
    const handleLanguageChange = (lang) => {
        i18n.changeLanguage(lang);
        setSelectedLanguage(lang);
        handleMenuClose();
    };
    const renderFlagIcon = (language) => {
        return _jsx("img", { width: 20, height: 15, src: flagMap[language], alt: language });
    };
    const checkIsLanguageDisabled = useCallback(() => {
        return (location.pathname.includes("directors") ||
            location.pathname.includes("external") ||
            location.pathname.includes("relations-day"));
    }, [location, location.pathname, i18n.language]);
    const languages = useMemo(() => [
        {
            src: "/assets/images/us-flag.svg",
            alt: "English",
            label: getLanguageDisplay(Language.EN, isLargeScreen),
            onClick: () => handleLanguageChange(Language.EN),
            isDisabled: false,
        },
        {
            src: "/assets/images/nl-flag.svg",
            alt: "Dutch",
            onClick: () => handleLanguageChange(Language.NL),
            label: getLanguageDisplay(Language.NL, isLargeScreen),
            isDisabled: false,
        },
        {
            src: "/assets/images/de-flag.svg",
            alt: "German",
            onClick: () => handleLanguageChange(Language.DE),
            label: getLanguageDisplay(Language.DE, isLargeScreen),
            isDisabled: checkIsLanguageDisabled(),
        },
    ], [location, location.pathname, i18n.language, selectedLanguage]);
    return {
        languages,
        renderFlagIcon,
    };
};
export default useSwitchLanguage;
